import { createSelector } from 'reselect';

const userSelector = state => state.subscription.user;

export const userIsMovementSpecialist = createSelector(
  userSelector,
  user => !!user.get('data') && user.getIn(['data', 'roles']).indexOf('ms') >= 0
);

export const hasMsAdminAccess = createSelector(
  userSelector,
  userIsMovementSpecialist,
  (user, userIsMs) =>
    !!user.get('data') && (userIsMs || user.getIn(['data', 'courses']).some(course => course.get('ms_certification')))
);

export const selectSubscriptions = createSelector(
  userSelector,
  user => user.getIn(['data', 'subscriptions']) && user.getIn(['data', 'subscriptions']).toJS()
);

export const selectDefaultSource = createSelector(
  userSelector,
  user =>
    user.getIn(['data', 'customer', 'default_source']) &&
    user
      .getIn(['data', 'customer', 'sources', 'data'])
      .find(source => source.get('id') === user.getIn(['data', 'customer', 'default_source']))
);

export const selectActiveSubscription = createSelector(userSelector, user => {
  if (!!user.getIn(['data', 'subscriptions'])) {
    const activeSubscription = user
      .getIn(['data', 'subscriptions'])
      .find(sub => ['active', 'trialing', 'past_due'].includes(sub.get('status')));

    return activeSubscription && activeSubscription.toJS();
  }
  return null;
});

export const hasActiveSubscription = createSelector(
  selectActiveSubscription,
  activeSubscription => !!activeSubscription
);

export const selectStripeCustomer = createSelector(
  userSelector,
  user => user.getIn(['data', 'customer']) && user.getIn(['data', 'customer']).toJS()
);



// WEBPACK FOOTER //
// ./src/subscription/redux/selectors.js